import { checkIsSignedorNot } from "../../../redux/slices/newRoleSlices";

/**
 * Signing state of one FLK document.
 *
 * "pending" is the state that used to be reported to candidates as an error:
 * FLK holds a freshly signed document in `awaiting_completion` for a few seconds
 * while it assembles the PDF. The candidate HAS signed — the app must wait, not
 * tell them to sign again.
 */
export type FlkDocStatus = "signed" | "pending" | "not_signed" | "error";

export type FlkStatusResult = {
    status: FlkDocStatus;
    message: string;
};

export const checkDocumentSignedStatus = async (
    dispatch: any,
    candidateId: string,
    formName: string,
    activePageNumber: number,
    formType: "TFN" | "SUPER" | "DYNAMIC",
    flkFormName?: string | null
): Promise<FlkStatusResult> => {

    const obj: any = {
        CandidateId: candidateId,
        formName,
        activePageNumber,
        isTfnForm: formType === "TFN",
        isSuperForm: formType === "SUPER",
        isDynamicFlkForm: formType === "DYNAMIC",
        // Dynamic forms keep one document per form name, so the backend needs the
        // flk_config.dynamicFormName key to look up the right document id. The
        // page label is not that key.
        flkFormName: flkFormName || "",
    };

    const response = await dispatch(checkIsSignedorNot(obj));
    const payload = response?.payload?.data;
    const message: string = payload?.message || "";

    if (!payload) {
        return { status: "error", message: "" };
    }

    // Prefer the machine-readable field. The message fallback keeps this working
    // against a backend that has not been deployed yet.
    const status: FlkDocStatus = payload?.docStatus
        ? payload.docStatus
        : (message === "Form Signed" ? "signed" : "not_signed");

    return { status, message };
};
